/**
 * States to indicate the current 3DS flow
 */
export enum ThreeDSState {
  REDIRECT = 'redirect',
  IDENTIFY = 'identify',
  CHALLENGE = 'challenge',
}
